module.exports = __webpack_public_path__ + "img/ht_icon_close_circle_line.eb47a0b4.svg";